<div class="account-tab">

    <div class="title">Accounts</div>

    <!-- Email Channel Disabled Banner -->
    <div *ngIf="isEmailDisabled"
        class="alert alert-info margin-bottom-20"
        style="background-color: #d1ecf1; border-color: #bee5eb; color: #0c5460; padding: 12px; border-radius: 4px;">
        <i class="fa fa-info-circle"></i> Email channel has been disabled.
    </div>

    <form [formGroup]="formGroup">

        <!-- CD Maturing -->
        <div class="row notify-group">

            <div class="task-icon-container col-md-1">
                <i class="fa-regular fa-bell fa-2x"></i>
            </div>

            <div class="col-md-10">

                <div class="row">
                    <div class="col-md-12">
                        <div class="font-bold margin-top-5">CD Maturing</div>
                        <div class="margin-top-5">Notifications when Certificate of Deposits (CDs) are about to mature.</div>
                    </div>
                </div>

                <div class="row margin-top-24">
                    <div class="col shrink-to-fit" style="margin-bottom: 8px; margin-top: 8px;">Begin weekly notifications starting</div>
                    <div class="col"><dx-select-box
                        formControlName="notifyDaysDropdown"
                        [items]="notifyDaysOptions"
                        displayExpr="text"
                        valueExpr="value"
                        placeholder="Select days"
                        (onValueChanged)="onNotifyDaysChanged($event)"
                        class="notify-days-select">
                    </dx-select-box></div>
                </div>
                    
                <div class="font-light margin-top-20">* Notifications are only sent to account admins.</div>
            </div>

            <div class="col-md-1">
                <!-- Switch: remove the self-referential disable condition -->
                <dx-switch
                    formControlName="cdMaturingSwitch"
                    [value]="true"
                    [width]="50"
                    [switchedOnText]="''"
                    [switchedOffText]="''"
                    [disabled]="isEmailDisabled"
                    (onValueChanged)="onCdMaturingSwitchChanged($event)">
                </dx-switch>
            </div>
        </div>
    </form>

</div>